import { Box, Button, ButtonProps } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useSxStyles } from '~/scenes/MyWorkspace/components/Widgets/components/MyWorklistsWidget/components/common/MarkTaskActions/useStyles';

import { WorklistRowMode } from '../types';

type PropsType = {
  onUnselectAll: () => void;
  onUpdateTasks: (status: 'SKIPPED' | 'COMPLETED' | 'IN_PROGRESS') => void;
  hasTaskSelection: boolean;
  rowMode: WorklistRowMode;
};

export const MarkTaskActions = (props: PropsType) => {
  const { rowMode, hasTaskSelection, onUnselectAll, onUpdateTasks } = props;

  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  const commonButtonProps: Partial<ButtonProps> = {
    variant: 'contained',
    size: 'small',
    sx: sxStyles.markButtons,
    disabled: !hasTaskSelection,
  };

  return (
    <Box
      sx={
        rowMode !== WorklistRowMode.Table
          ? sxStyles.buttonContainerCompact
          : sxStyles.buttonContainer
      }
    >
      <Button {...commonButtonProps} color="primary" onClick={onUnselectAll}>
        {t('unselectAll')}
      </Button>
      <Button
        {...commonButtonProps}
        color="secondary"
        onClick={() => onUpdateTasks('SKIPPED')}
      >
        {t('markSkipped')}
      </Button>
      <Button
        {...commonButtonProps}
        color="success"
        onClick={() => onUpdateTasks('COMPLETED')}
      >
        {t('markDone')}
      </Button>
      <Button
        {...commonButtonProps}
        color="warning"
        onClick={() => onUpdateTasks('IN_PROGRESS')}
      >
        {t('markUndone')}
      </Button>
    </Box>
  );
};
